import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router } from "react-router-dom"
import App from "./App"
import { GlobalContextProvider } from "./context/GlobalContext"

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <Router>
    <GlobalContextProvider>
      <App />
    </GlobalContextProvider>
  </Router>
  // </React.StrictMode>
)
